import React, { useEffect } from "react";
import { RouterProvider } from "react-router";
import { connect } from "react-redux";
import { ThemeProvider } from "@mui/material/styles";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { Sentry } from "@/sentry";

import "./i18n"; // multi language support config file
import CssBaseline from "@mui/material/CssBaseline";
import ErrorFallback from "@/components/ErrorFallback";
import { router } from "@/router";
import "moment/min/locales.min";
import { initializeApp } from "@/store/actions";
import useThemeSettings from "@/hooks/useThemeSettings";

const App = (props) => {
  const { initializeApp } = props;
  const theme = useThemeSettings();
  useEffect(() => {
    initializeApp();
  }, [initializeApp]);

  // TODO move LocalizationProvider inside the component to take locales advantage
  return (
    <ThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <CssBaseline />
        <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
          <RouterProvider router={router} />
        </Sentry.ErrorBoundary>
      </LocalizationProvider>
    </ThemeProvider>
  );
};

const mapDispatchToProps = {
  initializeApp,
};

export default connect(null, mapDispatchToProps)(React.memo(App));
